<script setup lang="ts">
import Generic from '~/layouts/generic.vue'
import Header from '~/components/Layout/Header.vue'

</script>

<template>
  <Generic>
    <Header />
    <div class="mt-20 w-full bg-white md:mt-32">
      <router-view />
    </div>
  </Generic>
</template>
